var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12122_125526)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "matrix(-1 0 0 1 40 0)",
    fill: "#0057FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9985 13.0978C21.7334 13.0978 23.1452 14.5096 23.1452 16.2445C23.1452 17.9794 21.7334 19.3912 19.9985 19.3912C18.2636 19.3912 16.8518 17.9794 16.8518 16.2445C16.8518 14.5096 18.2636 13.0978 19.9985 13.0978ZM19.9985 11C17.0993 11 14.754 13.3474 14.754 16.2445C14.754 19.1416 17.0993 21.489 19.9985 21.489C22.8977 21.489 25.243 19.1416 25.243 16.2445C25.243 13.3474 22.8977 11 19.9985 11ZM19.9985 24.6358C22.1183 24.6358 23.4609 25.4445 23.9665 26.1514C23.2501 26.4241 21.9012 26.7336 19.9985 26.7336C17.9175 26.7336 16.6357 26.4137 15.9938 26.1651C16.4752 25.4151 17.8577 24.6358 19.9985 24.6358ZM19.9985 22.538C16.0651 22.538 13.7051 24.6358 13.7051 26.7336C13.7051 27.7825 16.0651 28.8314 19.9985 28.8314C23.6886 28.8314 26.2919 27.7825 26.2919 26.7336C26.2919 24.6358 23.8228 22.538 19.9985 22.538Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12122_125526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.63b6363e3af8887753432bb4af6f5534.svg";
export { ForwardRef as ReactComponent };